// extracted by mini-css-extract-plugin
export default {"container":"Story_container__y2++n","quote":"Story_quote__zPDdn","author":"Story_author__ZTKKl","quoteEm":"Story_quoteEm__x2OxF"};